import {
  GET_MATCHING_DATA,
  GET_MATCHING_DATA_SUCCESS,
  GET_MATCHING_DATA_FAIL
} from "./actionTypes";

export const getMatchingData = (jobId) => ({
  type: GET_MATCHING_DATA,
  payload: jobId,
});

export const getMatchingDataSuccess = (data) => ({
  type: GET_MATCHING_DATA_SUCCESS,
  payload: data,
});

export const getMatchingDataFail = (error) => ({
  type: GET_MATCHING_DATA_FAIL,
  payload: error,
});